<template>
  <div class="advanced-search-district">
    <div class="regions-wrap">
      <div class="regions-container">
        <div
          class="region-tab-wrap"
          v-for="tab in regionTabs"
          :key="tab.name"
          @click="clickedRegionTab(tab.name)"
          v-bind:class="{ active: regionTab === tab.name }"
        >
          <div class="region-tab-container">
            {{ tab.text }}
            <span class="arrow-right"></span>
          </div>
        </div>
      </div>
      <div class="districts-wrap">
        <atomic-district
          v-for="district in mixSelectedFilters"
          :key="district.dist_code"
          :district="district"
          @changeDistrict="$emit('changeDistrict', $event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import AtomicDistrict from '@/components/Stock/Filters/AtomicDistrict';
import { mapState } from 'vuex';
export default {
  props: {
    selectedDistricts: {
      type: Array,
      default: [],
    },
    icsType: {
      type: String,
      default: '',
    },
  },
  components: {
    AtomicDistrict,
  },
  data() {
    return {
      regionTab: 'hk',
      regionTabs: [
        {
          name: 'hk',
          text: this.$t('main.HK_REGION'),
        },
        {
          name: 'kln',
          text: this.$t('main.KLN_REGION'),
        },
        {
          name: 'nt',
          text: this.$t('main.NT_REGION'),
        },
      ],
    };
  },
  computed: {
    ...mapState('districts', {
      regionRawHK: 'regionHK',
      regionRawKLN: 'regionKLN',
      regionRawNT: 'regionNT',
    }),
    mixSelectedFilters() {
      if (this.region) {
        return this.region
          .map(dist18 => {
            switch (this.icsType) {
              case 'i':
              case 'c':
              case 's':
                return dist18.district.filter(d => d.ics_type.some(it => it === this.icsType));
              default:
                return dist18.district;
            }
          })
          .flat()
          .map(d => ({
            ...d,
            isChecked: this.selectedDistricts.includes(d.dist_code),
          }));
      }
      return [];
    },
    region() {
      switch (this.regionTab) {
        case 'hk':
          return this.regionRawHK.dist18;
        case 'kln':
          return this.regionRawKLN.dist18;
        case 'nt':
          return this.regionRawNT.dist18;
      }
    },
  },
  methods: {
    clickedRegionTab(val) {
      this.regionTab = val;
    },
  },
  watch: {
    icsType(value) {
      if (value && this.selectedDistricts.length > 0) {
        const districtActions = {};
        if (this.regionRawHK && this.regionRawHK.dist18) {
          this.regionRawHK.dist18.forEach(districts => {
            districts.district.forEach(d => {
              if (!d.ics_type.includes(value) && this.selectedDistricts.includes(d.dist_code))
                districtActions[d.dist_code] = false;
            });
          });
        }
        if (this.regionRawKLN && this.regionRawKLN.dist18) {
          this.regionRawKLN.dist18.forEach(districts => {
            districts.district.forEach(d => {
              if (!d.ics_type.includes(value) && this.selectedDistricts.includes(d.dist_code))
                districtActions[d.dist_code] = false;
            });
          });
        }
        if (this.regionRawNT && this.regionRawNT.dist18) {
          this.regionRawNT.dist18.forEach(districts => {
            districts.district.forEach(d => {
              if (!d.ics_type.includes(value) && this.selectedDistricts.includes(d.dist_code))
                districtActions[d.dist_code] = false;
            });
          });
        }

        if (Object.keys(districtActions).length > 0) {
          this.$emit('changeDistrict', districtActions);
        }
      }
    },
  },
};
</script>
<style scoped>
.regions-wrap {
  display: flex;
}

.arrow-right {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 4px solid black;
}

.region-tab-wrap {
  cursor: pointer;
  font-size: 16px;
  line-height: 20px;
  height: 36px;
  display: flex;
}

.region-tab-wrap.active,
.district-wrap {
  background: #f8f8f8;
}

.regions-container {
  padding-top: 8px;
  background: white;
}

.districts-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  height: 303px;
  padding: 16px 42px 15px 24px;
  background: #f8f8f8;
  gap: 16px;
  overflow: auto;
}

.districts-wrap >>> .md-checkbox label:before {
  border-radius: 2px;
  border: 1px solid #9a9a9a;
  width: 18px;
  height: 18px;
}

.districts-wrap >>> label {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 20px;
  color: black;
}
.districts-wrap >>> .md-checkbox {
  margin: 0;
}
.region-tab-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 40px;
}

/* not mobile */
@media (min-width: 992px) {
  .region-tab-wrap {
    min-width: 240px;
    width: -webkit-fill-available;
  }

  .region-tab-container {
    width: 160px;
    margin: auto 40px auto auto;
  }
}
/* mobile */
@media (max-width: 991px) {
  .regions-container {
    flex: 1 0 40%;
  }
  .districts-wrap {
    height: auto;
    flex-wrap: nowrap;
    overflow-y: auto;
  }

  .regions-wrap,
  .advanced-search-district {
    height: 100%;
  }
}
</style>
